import { c as _c } from "react/compiler-runtime";
import { IssueTypeProvider } from "@/components/issue/issue-type-provider";
import { PriorityBadge } from "@/components/issue/priority-badge";
import { StatusBadge } from "@/components/issue/status-badge";
import { Attachment } from "@/components/ui/attachment";
import { Assignee } from "@/components/issue/assignee";
import { cn } from "@/lib/utils";

// default layout. use this if you don't want to customize the layout
export default function IssueLayout(t0) {
  const $ = _c(32);
  const {
    children,
    issue,
    users
  } = t0;
  let t1;
  if ($[0] !== issue.type) {
    t1 = <IssueTypeProvider issueType={issue.type} />;
    $[0] = issue.type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== issue.title) {
    t2 = <Title>{issue.title}</Title>;
    $[2] = issue.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] !== issue) {
    t3 = <StatusBadge issue={issue} />;
    t4 = <PriorityBadge issue={issue} />;
    $[4] = issue;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== users) {
    t5 = users ?? [];
    $[7] = users;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !users || !users?.length;
  let t7;
  if ($[9] !== issue || $[10] !== t5 || $[11] !== t6) {
    t7 = <Assignee issue={issue} users={t5} disabled={t6} />;
    $[9] = issue;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t7) {
    t8 = <StatusRow>{t3}{t4}{t7}</StatusRow>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== issue.description) {
    t9 = <Description><div>{issue.description}</div></Description>;
    $[17] = issue.description;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== issue.resolvedAttachments) {
    t10 = issue.resolvedAttachments?.map(_temp);
    $[19] = issue.resolvedAttachments;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <Attachments>{t10}</Attachments>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== children) {
    t12 = <Content>{children}</Content>;
    $[23] = children;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t1 || $[26] !== t11 || $[27] !== t12 || $[28] !== t2 || $[29] !== t8 || $[30] !== t9) {
    t13 = <><Viewport>{t1}{t2}{t8}{t9}{t11}{t12}</Viewport></>;
    $[25] = t1;
    $[26] = t11;
    $[27] = t12;
    $[28] = t2;
    $[29] = t8;
    $[30] = t9;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}
function _temp(attachment) {
  return <Attachment attachment={attachment} key={attachment.id} />;
}
const Root = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let issue;
  let props;
  if ($[0] !== t0) {
    ({
      issue,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = issue;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    issue = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== issue.type) {
    t1 = <IssueTypeProvider issueType={issue.type} />;
    $[5] = issue.type;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== className) {
    t2 = cn(className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== props || $[11] !== t2) {
    t3 = <div {...props} className={t2}>{children}</div>;
    $[9] = children;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
const Viewport = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("-ml-[var(--page-padding-left)] -mr-[var(--page-padding-right)] flex max-w-4xl flex-col gap-8 border-y border-slate-6 bg-slate-2 p-6 sm:mx-auto sm:gap-8 sm:border sm:p-10 md:rounded-md lg:px-12 lg:py-10", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div {...props} className={t1}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
const Title = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("text-3xl/9 font-extrabold", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <h1 className={t1} {...props}>{children}</h1>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
const StatusRow = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("-mt-4 flex flex-row flex-wrap items-center gap-4", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
const Description = t0 => {
  const $ = _c(21);
  let children;
  let className;
  let dangerouslySetInnerHTML;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      children,
      className,
      title,
      dangerouslySetInnerHTML,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = dangerouslySetInnerHTML;
    $[4] = props;
    $[5] = title;
  } else {
    children = $[1];
    className = $[2];
    dangerouslySetInnerHTML = $[3];
    props = $[4];
    title = $[5];
  }
  if (!dangerouslySetInnerHTML || !dangerouslySetInnerHTML.__html) {
    return null;
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn(className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = title ?? "About this issue";
  let t3;
  if ($[8] !== t2) {
    t3 = <h2 className="text-lg/7 text-slate-10">{t2}</h2>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <hr className="mt-2 border-slate-6" />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3) {
    t5 = <div>{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== children || $[14] !== dangerouslySetInnerHTML) {
    t6 = dangerouslySetInnerHTML ? <div className="prose mt-6" dangerouslySetInnerHTML={dangerouslySetInnerHTML} /> : <div className="prose mt-6">{children}</div>;
    $[13] = children;
    $[14] = dangerouslySetInnerHTML;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== props || $[17] !== t1 || $[18] !== t5 || $[19] !== t6) {
    t7 = <section {...props} className={t1}>{t5}{t6}</section>;
    $[16] = props;
    $[17] = t1;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
const Attachments = t0 => {
  const $ = _c(13);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("grid gap-6", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><h2 className="text-lg/7 text-slate-10">Links</h2><hr className="mt-2 border-slate-6" /></div>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children) {
    t3 = <div className="divide-y divide-slate-6 overflow-hidden rounded-md border border-slate-6">{children}</div>;
    $[7] = children;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props || $[10] !== t1 || $[11] !== t3) {
    t4 = <div {...props} className={t1}>{t2}{t3}</div>;
    $[9] = props;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
const Content = t0 => {
  const $ = _c(17);
  let children;
  let className;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      children,
      title,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = title;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    title = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn(className, "grid gap-6");
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = title ?? "Task details";
  let t3;
  if ($[7] !== t2) {
    t3 = <h2 className="text-lg/7 text-slate-10">{t2}</h2>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <hr className="mt-2 border-slate-6" />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3) {
    t5 = <div>{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== props || $[14] !== t1 || $[15] !== t5) {
    t6 = <section {...props} className={t1}>{t5}{children}</section>;
    $[12] = children;
    $[13] = props;
    $[14] = t1;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
IssueLayout.Viewport = Viewport;
IssueLayout.Title = Title;
IssueLayout.Description = Description;
IssueLayout.Attachments = Attachments;
IssueLayout.Content = Content;
IssueLayout.StatusRow = StatusRow;
IssueLayout.Root = Root;